import { useEffect, useRef, useState } from 'react';
import { apiJson } from '../api/client.js';
import { applyPortalBranding } from '../branding/applyPortalBranding.js';

/**
 * @param {string} [endpoint='/api/org/branding']
 */
export function usePortalBranding(endpoint = '/api/org/branding') {
  const rootRef = useRef(null);
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    let active = true;
    apiJson(endpoint)
      .then((data) => {
        if (active) {
          setBranding(data);
        }
      })
      .catch(() => {
        if (active) {
          setBranding(null);
        }
      });

    return () => {
      active = false;
    };
  }, [endpoint]);

  useEffect(() => {
    applyPortalBranding(rootRef.current, branding);
  }, [branding]);

  return { rootRef, branding };
}
